import { AuditColumnsSchema } from '@mntn/api-contracts/_shared/audit-columns'
import { DateToIsoString } from '@mntn/api-contracts/_shared/date-to-iso-string'
import { Actors as A, Tenants as T } from '@mntn/auth-types'
import { IDSchema } from '@mntn/zod'
import { z } from 'zod'

const VideoAttachmentAuditSchema = z.object({
  createTime: DateToIsoString,
  updateTime: DateToIsoString,
  createdBy: AuditColumnsSchema.shape.createdBy,
  updatedBy: AuditColumnsSchema.shape.updatedBy,
})

export const VideoMimeTypeSchema = z.union([
  z.literal('video/mp4'),
  z.literal('video/webm'),
  z.literal('video/3gp'),
  z.literal('video/ogg'),
  z.literal('video/avi'),
  z.literal('video/mpeg'),
  z.literal('video/object'),
])

export type VideoMimeType = z.infer<typeof VideoMimeTypeSchema>

const ImageAttachmentResponseSchema = z.object({
  cropX: z.number().int().nullable(),
  cropY: z.number().int().nullable(),
  cropWidth: z.number().int().nullable(),
  cropHeight: z.number().int().nullable(),
  url: z.string(),
  imageAttachmentId: IDSchema,
})

const ImageAttachmentResponseWithCroppedUrlSchema = z.object({
  original: ImageAttachmentResponseSchema,
  croppedUrl: z.string(),
})

const InsertVideoAttachmentInputSchema = z.object({
  url: z.string().url(),
  mimeType: VideoMimeTypeSchema.nullish(),
})

export const VideoAttachmentSchema = z
  .object({
    videoAttachmentId: IDSchema,
    url: z.string().url(),
    mimeType: VideoMimeTypeSchema.nullish(),
    previewPosterUrl: z.string().url().nullish(),
    previewPosterImage: ImageAttachmentResponseWithCroppedUrlSchema.optional(),
  })
  .extend(VideoAttachmentAuditSchema.shape)

export const PostVideoAttachmentBodySchema = z.object({
  videoAttachments: z.array(InsertVideoAttachmentInputSchema),
})

export const PostVideoAttachmentResponseSchema = z.object({
  data: z.array(VideoAttachmentSchema),
})

export const DeleteVideoAttachmentBodySchema = z.object({
  videoAttachmentId: IDSchema,
})

export const DeleteVideoAttachmentResponseSchema = z.object({
  data: z.object({
    ok: z.boolean(),
  }),
})

export const PostVideoAttachmentRequestSchema = z.object({
  body: z.custom<z.output<typeof PostVideoAttachmentBodySchema>>(),
  principal: T.KindSchema('publisher').and(A.UserSchema),
})

export const DeleteVideoAttachmentRequestSchema = z.object({
  body: z.custom<z.output<typeof DeleteVideoAttachmentBodySchema>>(),
  principal: T.KindSchema('publisher').and(A.UserSchema),
})
